/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Position_Center_LabelInputs */



/**
* | output |
* | --- |
* | "Center" |
*
* @param {Style_Guide_Manager_Position_Center_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_position_center_label = /** @type {((inputs?: Style_Guide_Manager_Position_Center_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Position_Center_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Centre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Center")
	if (locale === "it") return /** @type {LocalizedString} */ ("Centro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Центр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Centro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("中心")
	if (locale === "ja") return /** @type {LocalizedString} */ ("中心")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केंद्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centro")
	return /** @type {LocalizedString} */ ("Center")
});